import config from 'emun.retailer/retailer.config'
import $appConfig from 'servicestack/config'

class DashboardItemsSoldController  {
    constructor(createAutoQuery, $session, $scope) {
        let $ctrl = this;
        let options = {
            url: 'QueryOrderLineTotals.json',
            criteria: {
                dateRange: $ctrl.date,
                startDate: $ctrl.start,
                endDate: $ctrl.end,
                vendorId: $ctrl.vendor
            },
            autoLoad: true,
            take: $ctrl.top
        };
        $ctrl.query = createAutoQuery(options);
        $ctrl.productImage = $appConfig.productImage;
        $ctrl.$session = $session;
        $scope.$watch("$ctrl.date", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.start", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.end", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.vendor", function () {
            $ctrl.reload();
        });
    }
    reload() {
        this.query.criteria.dateRange = this.date;
        this.query.criteria.startDate = this.start;
        this.query.criteria.endDate = this.end;
        this.query.criteria.vendorId = this.vendor;
        this.query.load(true);
    }
}

class DashboardItemsSold{
    constructor(){
        this.bindings= {
            date: '@',
            start: '@',
            end: '@',
            top: '@',
            vendor: '@'
        };
        this.controller = DashboardItemsSoldController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-items-sold.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardItemsSold', new DashboardItemsSold());

export default DashboardItemsSold